<div [style.height]="height()" layout-horizontal layout-align-items-center>
  <rt-icon name="rating-thumbs-up-down" [size]="size()" margin-right-small-xx />
  <div class="asterisks">
    <rt-icon name="asterisk-new" size="small-xxx" />
    <rt-icon name="asterisk-new" size="small-xxx" />
    <rt-icon name="asterisk-new" size="small-xxx" />
  </div>
</div>
